export const booleanAttribute = (element: Element, attribute: string): true | undefined => element.getAttribute(attribute) !== null || undefined
